import { Currency, CurrencyType } from '@heliofi/common';
import { ApiAdapter } from '../ApiAdapter';

export class CurrencySDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async getAllCurrencies(type?: CurrencyType): Promise<Currency[]> {
    return this.apiAdapter.get(
      '/currency',
      'Failed to get currencies',
      type ? { type } : undefined,
    );
  }
}
